import { formatDate } from 'utils/formatString';

const getSubscriptionCaption = (dueSubscriptionDate) => `Подписка действует до ${formatDate(dueSubscriptionDate)} года, после чего нужно будет подтвердить её продление`;

export { getSubscriptionCaption };
